import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64867e59"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "organization-card__header" }
const _hoisted_2 = { class: "organization-card__name" }
const _hoisted_3 = { class: "organization-card__info" }

import { computed, PropType } from 'vue'
import { OrganizationType } from '@/shared/types'
import { getDateDistance } from '@/shared/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  organization: Object as PropType<OrganizationType>,
  active: Boolean as PropType<boolean>,
},
  setup(__props) {

const props = __props



const isSubscriptionEnded = computed((): boolean => {
  return !getDateDistance(props.organization.block_at)
})

const dateDistance = computed(() => {
  return getDateDistance(props.organization.block_at)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["organization-card", {
      'organization-card--active': __props.active,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", {
        class: _normalizeClass(["organization-card__name", {
          'organization-card__name--blocked':
            !__props.organization.package_count || _unref(isSubscriptionEnded),
        }])
      }, _toDisplayString(__props.organization.name), 3),
      _createElementVNode("p", _hoisted_2, "№" + _toDisplayString(__props.organization.id), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, "Врачей: " + _toDisplayString(__props.organization.users_count), 1),
      (!__props.organization.is_blocked)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("p", null, " Дней: " + _toDisplayString(_unref(dateDistance)), 1),
            _createElementVNode("p", null, "Отчетов: " + _toDisplayString(__props.organization.package_count), 1)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})